import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'

import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import ModalAlert from '../../components/ModalAlert';
import {getAppCfg} from '../../utils/common'
import AddressesView from './AddressesView';
import crmservices from '../../wsclient/crmservices';
import AddAdresses from './AddAdresses';
import { setOrderCache, order_key } from '../../utils/order_cache';
import CurrentLocationControler from './CurrentLocationControler';

const styles = theme => ({

});


function Addresses(props) {
    const [addresses, setAddresses] = useState({});
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const [addAddresses, setAddAddresses] = useState ({
        open: false,
        mode:null,
        address: null
    })
    const [showLoading, onShowLoading] = useState(false);
    const [openCurrenLocation, onOpenCurrenLocation] = useState(false);
    
    useEffect(()=>{
        onLoadAddresses();
    },[])

    const onLoadAddresses = async() =>{
        onShowLoading(true)
        try {
            var result = await crmservices.contacts.getAddresses();
            console.log('onLoadAddresses result==',result)
            if (result.code === 'OK') {
                var addresses = result.data && result.data.content ? result.data.content : []; 
                setAddresses(addresses)
            }
        } catch (error) {
            console.log('load addresses exception:', error);
        }
        onShowLoading(false);
    }
    const onAddAddresses = () =>{
        setAddAddresses(prevState=>({
            ...prevState,
            open: true,
            mode: 'add',
            address: {}
        }))
    }
    const onCloseAddAddresses = () =>{
        setAddAddresses(prevState=>({
            ...prevState,
            open: false,
        }))
    }
    const onShowDetail = (add) =>{
        //console.log(' add=====', add)
        var from = props.from;
        if(from && from==='order'){
            setOrderCache(order_key.delivery_address,add);
            props.onCloseItem("address_book");
            if(props.reOrder){
                props.onInitReOrderDelivery();
            }
        }else { 
            setAddAddresses(prevState=>({
                ...prevState,
                open: true,
                mode: 'edit',
                address: add
            }))
        }
    }
    const onRemoveAddress = async(address) =>{
        //console.log("address:", address);
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.removeAddress(address.id);
            if (result.code == 'OK') {
                await onLoadAddresses();
                showAlert(t('SUCCESS'), t('REMOVE_ADDRESS_SUCCESS'));
            } else {
                showAlert(t('ERROR'), t('FAILED_TO_REMOVE_ADDRESS'));
            }
        } catch (error) {
            console.log("remove address exception:", error);
            showAlert(t('ERROR'), t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false)
    }
    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({                
            showAlert: true,
            title: title,
            message: message,
            status: status
        })
    }
    const onCloseAlert = () =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        })
    }
    const setCurrentLocation = (address_info) =>{
        console.log('setCurrentLocation  address_info===', address_info)
        onOpenCurrenLocation(false);
        props.onGoBackAfterSetCurrentAddress(address_info);
    }
    return (
        <div>
            <AddressesView
                showLoading = {showLoading}
                open = {props.open}
                handleDrawerOtherToggle = {props.onCloseItem}                 
                addresses = {addresses}
                onAddAddresses = {onAddAddresses}
                onRemoveAddress = {onRemoveAddress}
                onShowDetail = {onShowDetail}
                openFromOrder = {props.from && props.from==='order'}
                onSelectCurrentLocation = {()=>onOpenCurrenLocation(true)}/>
            {addAddresses.open&&<AddAdresses
                open = {addAddresses.open}
                mode = {addAddresses.mode}
                address = {addAddresses.address}
                onClose = {onCloseAddAddresses}
                onLoadAddresses = {onLoadAddresses}/>}
            {openCurrenLocation&&<CurrentLocationControler
                open = {openCurrenLocation}
                onClose = {()=>onOpenCurrenLocation(false)}
                setCurrentLocation = {setCurrentLocation}/>}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
        </div>
    );
}

// export default MyProfile;
export default withStyles(styles)(withTranslation()(Addresses));